import type { OptionRow } from '@/types'

/**
 * True when an estimate carries at least one real optional add-on.
 *
 * Deliberately not `optionsData.length > 0`. OptionsPanel seeds a blank row
 * (`{ name: '', description: '', cost: 0 }`), so merely opening the Options tab
 * persists a non-empty array — length alone would flag estimates that have no
 * options at all.
 */
export function hasRealOptions(rows: OptionRow[] | undefined | null): boolean {
  if (!Array.isArray(rows)) return false
  return rows.some((r) => (r?.name ?? '').trim() !== '' || (r?.cost ?? 0) > 0)
}
